export enum GoodPracticeTranslationStatus {
  S = 'S', // Started
  F = 'F', // Finished
}
